import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/lib/legal-content";

export const Route = createFileRoute("/sla")({
  component: SLAPage,
  head: () => ({
    meta: [
      { title: "Service Level Agreement — CoderLity" },
      { name: "description", content: "CoderLity's service level commitments, uptime targets and response times." },
    ],
    links: [{ rel: "canonical", href: "https://coderlity.com/sla" }],
  }),
});

function SLAPage() {
  return (
    <LegalPage
      eyebrow="Legal"
      title="Service Level Agreement"
      sub="Our uptime, response and resolution commitments."
      updated="May 1, 2026"
      sections={[
        { heading: "Uptime", body: "Hosting and SaaS products target 99.9% monthly uptime, excluding scheduled maintenance windows announced in advance." },
        { heading: "Support response times", body: "Critical: 1 hour · High: 4 hours · Normal: 1 business day · Low: 3 business days. 24/7 for production-down on Enterprise plans." },
        { heading: "Credits", body: "If we miss the uptime target, eligible customers receive service credits — 10% of monthly fee per 0.1% below target, up to 50%." },
        { heading: "Exclusions", body: "Outages caused by customer code, third-party providers, force majeure, or actions outside CoderLity's control are excluded." },
        { heading: "Claims", body: "Submit credit claims within 30 days to support@coderlity.com with affected timeframe and impact." },
      ]}
    />
  );
}
